import { MenuEntry } from '@pancakeswap-libs/uikit'

const config: MenuEntry[] = [
  {
    label: 'Home',
    icon: 'HomeUpdatedIcon',
    href: '/',
  },
  {
    label: 'Trade',
    icon: 'TradeUpdatedIcon',
    items: [
      {
        label: 'Exchange',
        href: 'http://exchange.golduckswap.org/', // 'https://exchange.goosedefi.com/',
      },
      {
        label: 'Liquidity',
        href: 'http://exchange.golduckswap.org/', // 'https://exchange.goosedefi.com/#/pool',
      },
    ],
  },
  {
    label: 'Farms',
    icon: 'FarmUpdatedIcon',
    href: '/farms',
  },
  {
    label: 'Pools',
    icon: 'LotteryIcon',
    href: '/nests',
  },
  // {
  //   label: 'Pools',
  //   icon: 'PoolIcon',
  //   href: '/pools',
  // },
  {
    label: 'Gbeaks NFT',
    icon: 'FarmIcon',
    href: 'https://www.gbeaks.com',
  },
  {
    label: 'Golduck Shield',
    icon: 'NftIcon',
    href: 'https://play.google.com/store/apps/details?id=com.golden.vpndev',
  },
  // {
  //   label: 'Info',
  //   icon: 'InfoIcon',
  //   items: [
  //     {
  //       label: 'PancakeSwap',
  //       href: 'https://pancakeswap.info/token/0xF952Fc3ca7325Cc27D15885d37117676d25BfdA6',
  //     },
  //     {
  //       label: 'CoinGecko',
  //       href: 'https://www.coingecko.com/en/coins/goose-finance',
  //     },
  //     {
  //       label: 'CoinMarketCap',
  //       href: 'https://coinmarketcap.com/currencies/goose-finance/',
  //     },
  //     {
  //       label: 'AstroTools',
  //       href: 'https://app.astrotools.io/pancake-pair-explorer/0x19e7cbecdd23a16dfa5573df54d98f7caae03019',
  //     },
  //   ],
  // },
  {
    label: 'More',
    icon: 'MoreUpdatedIcon',
    items: [
      {
        label: 'Github',
        href: 'https://github.com/golduckprotocol/golduck', // 'https://github.com/goosedefi/',
      },
      // {
      //   label: 'gbeaks',
      //   href: 'http://www.gbeaks.com', // 'https://goosedefi.gitbook.io/goose-finance/',
      // },
      {
        label: 'Blog',
        href: 'https://golduck.org/crypto-school/', //  'https://goosefinance.medium.com/',
      },
    ],
  },
  // {
  //   label: 'Partnerships/IFO',
  //   icon: 'GooseIcon',
  //   href: 'https://docs.google.com/forms/d/e/1FAIpQLSe7ycrw8Dq4C5Vjc9WNlRtTxEhFDB1Ny6jlAByZ2Y6qBo7SKg/viewform?usp=sf_link',
  // },http://www.gbeaks.com
  // {
  //   label: 'Audit by Hacken',
  //   icon: 'AuditIcon',
  //   href: 'https://www.goosedefi.com/files/hackenAudit.pdf',
  // },
  // {
  //   label: 'Audit by CertiK',
  //   icon: 'AuditIcon',
  //   href: 'https://certik.org/projects/goose-finance',
  // },
]

export default config
